//区域管理
import http from '../jslibs/axios/http';
import dLAxiosFile from '@/jslibs/axios/download-file';
import dkAxiosFile from '@/jslibs/axios/axios-file';

//获取视频列表 
export const getCVideoList = data => http.get('/cms/CVideo', data);

//新增视频 
export const addCvideo = data => http.post('/cms/CVideo', data);

//删除视频 
export const deleteCVideo = data => http.delete('/cms/CVideo/'+data.id, data);

//修改视频 
export const editCVideo = data => http.put('/cms/CVideo/'+data.id, data);

//获取视频详情 
export const getCVideo = data => http.get('/cms/CVideo/'+data.id);


//获取专利列表 
export const getCPatentList = data => http.get('/cms/CPatent', data);

//新增专利 
export const addCPatent = data => http.post('/cms/CPatent', data);

//删除专利 
export const deleteCPatent = data => http.delete('/cms/CPatent/'+data.id, data);

//修改专利 
export const editCPatent = data => http.put('/cms/CPatent/'+data.id, data);

//获取专利详情 
export const getCPatent = data => http.get('/cms/CPatent/'+data.id);


//获取标准列表 
export const getCStandardList = data => http.get('/cms/CStandard', data);

//新增标准 
export const addCStandard = data => http.post('/cms/CStandard', data);

//删除标准 
export const deleteCStandard = data => http.delete('/cms/CStandard/'+data.id, data);

//修改标准 
export const editCStandard = data => http.put('/cms/CStandard/'+data.id, data);

//获取标准详情 
export const getCStandard = data => http.get('/cms/CStandard/'+data.id);


//获取奖励列表 
export const getCAwardList = data => http.get('/cms/CAward', data);

//新增奖励 
export const addCAward = data => http.post('/cms/CAward', data);

//删除奖励 
export const deleteCAward = data => http.delete('/cms/CAward/'+data.id, data);

//修改奖励 
export const editCAward = data => http.put('/cms/CAward/'+data.id, data);

//获取奖励详情 
export const getCAward = data => http.get('/cms/CAward/'+data.id);



//获取荣誉列表 
export const getCHonorList = data => http.get('/cms/CHonor', data);

//新增荣誉 
export const addCHonor = data => http.post('/cms/CHonor', data);

//删除荣誉 
export const deleteCHonor = data => http.delete('/cms/CHonor/'+data.id, data);

//修改荣誉 
export const editCHonor = data => http.put('/cms/CHonor/'+data.id, data);

//获取荣誉详情 
export const getCHonor = data => http.get('/cms/CHonor/'+data.id);


//获取资质列表 
export const getCCertificationList = data => http.get('/cms/CCertification', data);

//新增资质 
export const addCCertification = data => http.post('/cms/CCertification', data);

//删除资质 
export const deleteCCertification = data => http.delete('/cms/CCertification/'+data.id, data);

//修改资质 
export const editCCertification = data => http.put('/cms/CCertification/'+data.id, data);

//获取资质详情 
export const getCCertification = data => http.get('/cms/CCertification/'+data.id);



//获取检测报告列表 
export const getCReportList = data => http.get('/cms/CReport', data);

//新增检测报告 
export const addCReport = data => http.post('/cms/CReport', data);

//删除检测报告 
export const deleteCReport = data => http.delete('/cms/CReport/'+data.id, data);

//修改检测报告 
export const editCReport = data => http.put('/cms/CReport/'+data.id, data);

//获取检测报告详情 
export const getCReport = data => http.get('/cms/CReport/'+data.id);


//获取公司介绍列表 
export const getCompanyList = data => http.get('/cms/CCompanyIntro', data);

//新增公司介绍 
export const addCompany = data => http.post('/cms/CCompanyIntro', data);

//删除公司介绍 
export const deleteCompany = data => http.delete('/cms/CCompanyIntro/'+data.id, data);

//修改公司介绍 
export const editCompany = data => http.put('/cms/CCompanyIntro/'+data.id, data);

//获取公司介绍详情 
export const getCompany = data => http.get('/cms/CCompanyIntro/'+data.id);



//获取宣传页列表 
export const getCPublicityList = data => http.get('/cms/CPublicity', data);

//新增宣传页 
export const addCPublicity = data => http.post('/cms/CPublicity', data);

//删除宣传页 
export const deleteCPublicity = data => http.delete('/cms/CPublicity/'+data.id, data);

//修改宣传页 
export const editCPublicity = data => http.put('/cms/CPublicity/'+data.id, data);

//获取宣传页详情 
export const getCPublicity = data => http.get('/cms/CPublicity/'+data.id);